@if (loading()) {
<div class="flex items-center justify-center h-64">
  <div class="flex flex-col items-center gap-2">
    <div
      class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-400"
    ></div>
    <div class="text-gray-600 text-sm">Loading brand data...</div>
  </div>
</div>
} @else if (brandData()) {
<app-brand-form-wrapper
  #formWrapper
  [config]="config"
  [editMode]="true"
  [viewMode]="false"
  [initialData]="brandData()"
></app-brand-form-wrapper>
} @else {
<div class="flex items-center justify-center h-64">
  <div class="text-gray-600">Brand not found</div>
</div>
}
